var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoPerson = function SvgIcoPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M10 10a3.332 3.332 0 1 0 0-6.667 3.33 3.33 0 0 0-3.333 3.334A3.33 3.33 0 0 0 10 10m0 1.667c-2.225 0-6.667 1.116-6.667 3.333v.833c0 .459.375.834.834.834h11.666a.836.836 0 0 0 .834-.834V15c0-2.217-4.442-3.333-6.667-3.333"
  })));
};
export default SvgIcoPerson;